module.exports = __webpack_public_path__ + "img/dikogbtlogo.4a4441a6.svg";